import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "dialog-back"

  connect() {
    this.observer?.disconnect()
    this.removePendingCallbacks()
    this.pendingMessageCallbacks = []
    super.connect()
    this.reportedOpen = null
    this.modals = Array.from(this.element.querySelectorAll("dialog:modal"))
    const focused = document.activeElement?.closest("dialog:modal")
    if (focused) this.recordOpening(focused)
    this.observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === "attributes" && record.oldValue === null) this.recordOpening(record.target)
      }
      this.synchronize()
    })
    this.observer.observe(this.element, {
      subtree: true, childList: true, attributes: true, attributeFilter: [ "open" ], attributeOldValue: true
    })
    // Keep this callback alive even after close: a Back already in flight must
    // acknowledge "no modal" so Android can return it to framework navigation.
    this.send("connect", {}, message => this.cancel(message.data.requestId))
    this.synchronize()
  }

  disconnect() {
    this.observer?.disconnect()
    this.send("closed")
    super.disconnect()
  }

  synchronize() {
    const open = this.modal() !== null
    if (open === this.reportedOpen) return

    this.reportedOpen = open
    this.send(open ? "opened" : "closed")
  }

  cancel(requestId) {
    const active = this.element.isConnected && !document.hidden &&
      document.documentElement.getAttribute("data-native-machine-motion-active") !== "false"
    const dialog = active ? this.modal() : null
    if (dialog?.dispatchEvent(new Event("cancel", { cancelable: true }))) dialog.close()
    this.synchronize()
    this.send(dialog ? "handled" : "unhandled", { requestId })
  }

  recordOpening(dialog) {
    if (!dialog.matches("dialog:modal") || !this.element.contains(dialog)) return

    this.modals = this.modals.filter(candidate => candidate !== dialog)
    this.modals.push(dialog)
  }

  modal() {
    this.modals = this.modals.filter(dialog => this.element.contains(dialog) && dialog.matches("dialog:modal"))
    return this.modals.at(-1) || null
  }
}
